/**
 * Product avatar SVG icons for the AppSwitcher.
 * Ported from Elements v5 src/core/app-switcher/app-avatar/icons/.
 *
 * Each product has an "accessible" (full colour) and "inaccessible" (greyed) variant.
 * The SVGs are 40x40 rounded squares with the product's brand mark.
 */
import * as React from 'react'

type SvgProps = React.SVGProps<SVGSVGElement>

// ---------------------------------------------------------------------------
// Reapit PM (consoleCloud)
// ---------------------------------------------------------------------------

function ReapitPMIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path fill="url(#reapit-pm__a)" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
      <path
        fill="#fff"
        d="M8.375 13v14L20.5 34l12.124-7v-7.737l-1.687-.975-2.806-1.62-1.082-.624v4.83l-.002 4.83H13.95V16.07l3.275-1.89 2.192-1.265 1.082-.625 3.275 1.877 2.192 1.256 1.083.62V9.782L20.5 6 8.376 13Z"
      />
      <defs>
        <linearGradient id="reapit-pm__a" x1="20.702" x2="20.702" y1=".351" y2="31.228" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5573FD" />
          <stop offset=".575" stopColor="#4E56EA" />
        </linearGradient>
      </defs>
    </svg>
  )
}

function ReapitPMDisabledIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path
        fill="url(#reapit-pm-disabled__a)"
        d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z"
      />
      <path
        fill="#fff"
        d="M8.375 13v14L20.5 34l12.124-7v-7.737l-1.687-.975-2.806-1.62-1.082-.624v4.83l-.002 4.83H13.95V16.07l3.275-1.89 2.192-1.265 1.082-.625 3.275 1.877 2.192 1.256 1.083.62V9.782L20.5 6 8.376 13Z"
      />
      <defs>
        <linearGradient
          id="reapit-pm-disabled__a"
          x1="20.702"
          x2="20.702"
          y1=".351"
          y2="31.228"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".075" stopColor="#798DA1" />
          <stop offset=".575" stopColor="#607890" />
        </linearGradient>
      </defs>
    </svg>
  )
}

// ---------------------------------------------------------------------------
// Reapit Lettings (ireWeb)
// ---------------------------------------------------------------------------

function ReapitLettingsIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path
        fill="url(#reapit-lettings__a)"
        d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z"
      />
      <path
        fill="#fff"
        d="M32.576 6C12.293 6 8.776 25.887 7.424 34H9.1c.45-2.977 3.493-14.748 10.899-20.287 0 0-5.633 6.976-6.572 15.051 3.426-.652 13.845-3.372 16.056-12.927l-3.84-.61c1.352-1.351 4.909-5.17 6.931-9.226V6Z"
      />
      <defs>
        <linearGradient
          id="reapit-lettings__a"
          x1="20.702"
          x2="20.702"
          y1=".351"
          y2="31.228"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5573FD" />
          <stop offset=".575" stopColor="#4E56EA" />
        </linearGradient>
      </defs>
    </svg>
  )
}

function ReapitLettingsDisabledIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path
        fill="url(#reapit-lettings-disabled__a)"
        d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z"
      />
      <path
        fill="#fff"
        d="M32.576 6C12.293 6 8.776 25.887 7.424 34H9.1c.45-2.977 3.493-14.748 10.899-20.287 0 0-5.633 6.976-6.572 15.051 3.426-.652 13.845-3.372 16.056-12.927l-3.84-.61c1.352-1.351 4.909-5.17 6.931-9.226V6Z"
      />
      <defs>
        <linearGradient
          id="reapit-lettings-disabled__a"
          x1="20.702"
          x2="20.702"
          y1=".351"
          y2="31.228"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".075" stopColor="#798DA1" />
          <stop offset=".575" stopColor="#607890" />
        </linearGradient>
      </defs>
    </svg>
  )
}

// ---------------------------------------------------------------------------
// Reapit Sales (agentBox)
// ---------------------------------------------------------------------------

function ReapitSalesIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path fill="url(#reapit-sales__a)" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
      <path fill="#fff" d="M10.41 6v3.779h15.048v19.537h4.132V6H10.41Z" />
      <path fill="#fff" d="M20.967 34V13.837L10.41 9.78v20.166L20.967 34Z" />
      <defs>
        <linearGradient
          id="reapit-sales__a"
          x1="20.702"
          x2="20.702"
          y1=".351"
          y2="31.228"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5573FD" />
          <stop offset=".575" stopColor="#4E56EA" />
        </linearGradient>
      </defs>
    </svg>
  )
}

function ReapitSalesDisabledIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path
        fill="url(#reapit-sales-disabled__a)"
        d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z"
      />
      <path fill="#fff" d="M10.41 6v3.779h15.048v19.537h4.132V6H10.41Z" />
      <path fill="#fff" d="M20.967 34V13.837L10.41 9.78v20.166L20.967 34Z" />
      <defs>
        <linearGradient
          id="reapit-sales-disabled__a"
          x1="20.702"
          x2="20.702"
          y1=".351"
          y2="31.228"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".075" stopColor="#798DA1" />
          <stop offset=".575" stopColor="#607890" />
        </linearGradient>
      </defs>
    </svg>
  )
}

// ---------------------------------------------------------------------------
// KeyWhere
// ---------------------------------------------------------------------------

function KeyWhereIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path fill="#ECF3FF" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
      <path
        fill="#4E56EA"
        d="m30.68 23.655-4.2-4.196 3.989-3.984a4.243 4.243 0 0 0 0-5.986 4.257 4.257 0 0 0-5.995 0l-6.815 6.903-.014.025v-4.059c0-2.329-1.907-4.233-4.24-4.233-2.331 0-4.239 1.904-4.239 4.233v14.165c0 1.163.476 2.222 1.245 2.989l-.008.015a4.257 4.257 0 0 0 5.995 0l4.113-4.108 4.175 4.222a4.257 4.257 0 0 0 5.995 0 4.243 4.243 0 0 0 0-5.987v.001ZM13.407 8.764a3.558 3.558 0 0 1 3.56 3.555 3.558 3.558 0 0 1-3.56 3.555 3.558 3.558 0 0 1-3.56-3.555 3.558 3.558 0 0 1 3.56-3.555Zm.025 21.314a3.532 3.532 0 1 1 0-7.063 3.532 3.532 0 1 1 0 7.063Zm10.472-17.915a3.558 3.558 0 0 1 3.803-3.293 3.556 3.556 0 0 1 3.298 3.799A3.558 3.558 0 0 1 27.2 15.96a3.556 3.556 0 0 1-3.297-3.798Zm3.994 18.136a3.647 3.647 0 0 1-3.847-3.435 3.646 3.646 0 0 1 3.44-3.842 3.644 3.644 0 1 1 .408 7.276Z"
      />
    </svg>
  )
}

function KeyWhereDisabledIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path fill="#F2F4F6" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
      <path
        fill="#607890"
        d="m30.68 23.655-4.2-4.196 3.989-3.984a4.243 4.243 0 0 0 0-5.986 4.257 4.257 0 0 0-5.995 0l-6.815 6.903-.014.025v-4.059c0-2.329-1.907-4.233-4.24-4.233-2.331 0-4.239 1.904-4.239 4.233v14.165c0 1.163.476 2.222 1.245 2.989l-.008.015a4.257 4.257 0 0 0 5.995 0l4.113-4.108 4.175 4.222a4.257 4.257 0 0 0 5.995 0 4.243 4.243 0 0 0 0-5.987v.001ZM13.407 8.764a3.558 3.558 0 0 1 3.56 3.555 3.558 3.558 0 0 1-3.56 3.555 3.558 3.558 0 0 1-3.56-3.555 3.558 3.558 0 0 1 3.56-3.555Zm.025 21.314a3.532 3.532 0 1 1 0-7.063 3.532 3.532 0 1 1 0 7.063Zm10.472-17.915a3.558 3.558 0 0 1 3.803-3.293 3.556 3.556 0 0 1 3.298 3.799A3.558 3.558 0 0 1 27.2 15.96a3.556 3.556 0 0 1-3.297-3.798Zm3.994 18.136a3.647 3.647 0 0 1-3.847-3.435 3.646 3.646 0 0 1 3.44-3.842 3.644 3.644 0 1 1 .408 7.276Z"
      />
    </svg>
  )
}

// ---------------------------------------------------------------------------
// Lettings BDM (ireBdm)
// ---------------------------------------------------------------------------

function LettingsBDMIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path fill="#ECF3FF" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
      <path
        fill="#4C56F3"
        d="M31.134 8.083c-6.688 0-17.64 5.486-11.323 23.27h1.456s-1.033-3.718-1.209-6.292c10.92-2.944 11.453-12.402 11.076-16.978Z"
      />
      <path
        fill="#4C56F3"
        d="M16.906 14.772c-2.743-2.685-7.716-1.976-7.716-1.976-.13 3.048-.013 10.335 8.04 13.65-2.183-7.183-.324-11.674-.324-11.674Z"
      />
    </svg>
  )
}

function LettingsBDMDisabledIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path fill="#F2F4F6" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
      <path
        fill="#607890"
        d="M31.134 8.083c-6.688 0-17.64 5.486-11.323 23.27h1.456s-1.033-3.718-1.209-6.292c10.92-2.944 11.453-12.402 11.076-16.978Z"
      />
      <path
        fill="#607890"
        d="M16.906 14.772c-2.743-2.685-7.716-1.976-7.716-1.976-.13 3.048-.013 10.335 8.04 13.65-2.183-7.183-.324-11.674-.324-11.674Z"
      />
    </svg>
  )
}

// ---------------------------------------------------------------------------
// Move Me In (mmiWeb)
// ---------------------------------------------------------------------------

function MoveMeInIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <g clipPath="url(#movemein-a)">
        <path fill="#ECF3FF" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
        <path
          fill="#4E56EA"
          d="M20 7.769c7.183 0 13 5.694 13 12.692 0 5.122-3.115 9.702-7.946 11.706-.159.032-.254.064-.381.064a.821.821 0 0 1-.795-.541c-.19-.445.032-.923.477-1.113 4.195-1.718 6.897-5.694 6.897-10.116 0-5.885-4.743-10.697-10.703-10.992l-.581-.013c-6.23 0-11.283 4.962-11.283 11.005 0 3.881 2.13 7.508 5.562 9.48l.223.096c.381.19.826.286 1.303.286 1.623 0 2.933-1.227 3.317-2.952a5.515 5.515 0 0 1-1.251-.324 6.644 6.644 0 0 1-4.164-4.326c-.254-.89.414-1.813 1.4-1.813h10.107c.985 0 1.652.922 1.398 1.813-.75 2.495-2.978 4.392-5.716 4.674-.442 2.672-2.5 4.613-5.06 4.613-.73 0-1.43-.159-2.034-.445l-.318-.127C9.48 29.177 7 24.946 7 20.461 7 13.463 12.816 7.77 20 7.77Zm-2.701 6.774c.35 0 .635.286.636.635v4.2h-2.512v-4.2c0-.35.286-.635.636-.636h1.24Zm6.96 0c.35 0 .636.286.636.635v4.2h-2.51v-4.2c0-.35.286-.636.635-.636h1.24Z"
        />
      </g>
      <defs>
        <clipPath id="movemein-a">
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

function MoveMeInDisabledIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <g clipPath="url(#movemein-disabled-a)">
        <path fill="#F2F4F6" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
        <path
          fill="#607890"
          d="M20 7.769c7.183 0 13 5.694 13 12.692 0 5.122-3.115 9.703-7.946 11.706-.16.032-.255.064-.382.064a.82.82 0 0 1-.794-.541c-.19-.445.032-.923.477-1.113 4.195-1.718 6.897-5.694 6.897-10.116 0-6.075-5.054-11.006-11.284-11.006S8.685 14.418 8.685 20.46c0 3.881 2.13 7.507 5.562 9.479l.223.096c.381.19.826.286 1.303.286 1.623 0 2.933-1.227 3.317-2.952a5.51 5.51 0 0 1-1.251-.324 6.643 6.643 0 0 1-4.163-4.325c-.255-.89.413-1.813 1.398-1.813h10.108c.985 0 1.652.923 1.398 1.813-.751 2.495-2.979 4.393-5.717 4.674-.442 2.671-2.5 4.613-5.058 4.613a4.77 4.77 0 0 1-2.034-.445l-.319-.128C9.48 29.177 7 24.946 7 20.461 7 13.463 12.817 7.77 20 7.77Zm-2.701 6.774c.35 0 .636.286.636.635v4.2h-2.512v-4.2c0-.35.286-.635.636-.636h1.24Zm6.96 0c.35 0 .636.285.636.635v4.2h-2.51v-4.2c0-.35.286-.636.635-.636h1.24Z"
        />
      </g>
      <defs>
        <clipPath id="movemein-disabled-a">
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

// ---------------------------------------------------------------------------
// Reapit Forms (reapitForms)
// ---------------------------------------------------------------------------

function ReapitFormsIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path fill="#ECF3FF" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
      <path fill="#4E56EA" d="M31.917 8.042 7 20.181l8.608 2.32 10.827-8.6-7.233 10.466 9.373 8.591 3.341-24.916Z" />
    </svg>
  )
}

function ReapitFormsDisabledIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path fill="#F2F4F6" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
      <path fill="#607890" d="M31.917 8.042 7 20.181l8.608 2.32 10.827-8.6-7.233 10.466 9.373 8.591 3.341-24.916Z" />
    </svg>
  )
}

// ---------------------------------------------------------------------------
// Reapit Proposals (reapitProposals)
// ---------------------------------------------------------------------------

function ReapitProposalsIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path fill="#ECF3FF" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
      <path
        fill="#4E56EA"
        d="M16.037 11.648c-1.782-1.53-4.199-2.515-6.87-2.628v17.178c2.956.114 5.632 1.198 7.6 2.889.968.832 1.766 1.81 2.343 2.893V17.993c0-2.47-1.177-4.717-3.073-6.345ZM30.833 9.02c-2.671.113-5.089 1.098-6.87 2.628-1.896 1.628-3.073 3.874-3.073 6.344V31.98a10.076 10.076 0 0 1 2.343-2.893c1.968-1.691 4.644-2.776 7.6-2.89V9.02Z"
      />
    </svg>
  )
}

function ReapitProposalsDisabledIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path fill="#F2F4F6" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
      <path
        fill="#607890"
        d="M16.037 11.648c-1.782-1.53-4.199-2.515-6.87-2.628v17.178c2.956.114 5.632 1.198 7.6 2.889.968.832 1.766 1.81 2.343 2.893V17.993c0-2.47-1.177-4.717-3.073-6.345ZM30.833 9.02c-2.671.113-5.089 1.098-6.87 2.628-1.896 1.628-3.073 3.874-3.073 6.344V31.98a10.076 10.076 0 0 1 2.343-2.893c1.968-1.691 4.644-2.776 7.6-2.89V9.02Z"
      />
    </svg>
  )
}

// ---------------------------------------------------------------------------
// Reapit Websites (reapitWebsites)
// ---------------------------------------------------------------------------

function ReapitWebsitesIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path fill="#ECF3FF" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
      <path
        fill="#4E56EA"
        d="m17.713 16.581 3.058 3.057c2.352 2.352 4.84.257 5.793-1.265.562-.896 1.067-1.752 1.438-2.585.868-1.95 1.001-3.5.356-4.146-.646-.645-2.195-.512-4.146.356-2.06.917-4.346 2.533-6.498 4.583Zm8.355-6.841c-4.35-2.577-9.987-2.148-13.909 1.287l4.421 4.421c3.38-3.231 6.857-5.262 9.488-5.707Zm-15.041 2.419c-3.435 3.922-3.864 9.559-1.286 13.909.445-2.632 2.475-6.108 5.707-9.488l-4.421-4.421Zm8.988 15.231.002-.002c-2.217 1.58-4.337 2.576-6.084 2.871 4.35 2.578 9.986 2.149 13.909-1.286l-1.736-1.736c-2.567-2.567-4.366-1-6.091.153Zm-3.72.374c2.521-1.384 6.276-4.061 2.851-7.486l-2.565-2.565c-2.05 2.153-3.665 4.438-4.582 6.5-.868 1.95-1.001 3.5-.356 4.145.646.646 2.195.512 4.146-.355.168-.075.336-.155.506-.239ZM30.26 13.931c-.304 1.798-1.35 3.99-3.01 6.275-.137.176-.276.36-.412.551-.987 1.392-1.778 3.17.312 5.261l1.824 1.824c3.433-3.923 3.863-9.56 1.286-13.91Z"
      />
    </svg>
  )
}

function ReapitWebsitesDisabledIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path fill="#F2F4F6" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
      <path
        fill="#607890"
        d="m17.713 16.581 3.058 3.057c2.352 2.352 4.84.257 5.793-1.265.562-.896 1.067-1.752 1.438-2.585.868-1.95 1.001-3.5.356-4.146-.646-.645-2.195-.512-4.146.356-2.06.917-4.346 2.533-6.498 4.583Zm8.355-6.841c-4.35-2.577-9.987-2.148-13.909 1.287l4.421 4.421c3.38-3.231 6.857-5.262 9.488-5.707Zm-15.041 2.419c-3.435 3.922-3.864 9.559-1.286 13.909.445-2.632 2.475-6.108 5.707-9.488l-4.421-4.421Zm8.988 15.231.002-.002c-2.217 1.58-4.337 2.576-6.084 2.871 4.35 2.578 9.986 2.149 13.909-1.286l-1.736-1.736c-2.567-2.567-4.366-1-6.091.153Zm-3.72.374c2.521-1.384 6.276-4.061 2.851-7.486l-2.565-2.565c-2.05 2.153-3.665 4.438-4.582 6.5-.868 1.95-1.001 3.5-.356 4.145.646.646 2.195.512 4.146-.355.168-.075.336-.155.506-.239ZM30.26 13.931c-.304 1.798-1.35 3.99-3.01 6.275-.137.176-.276.36-.412.551-.987 1.392-1.778 3.17.312 5.261l1.824 1.824c3.433-3.923 3.863-9.56 1.286-13.91Z"
      />
    </svg>
  )
}

// ---------------------------------------------------------------------------
// Auto Responder (autoResponder)
// ---------------------------------------------------------------------------

function AutoResponderIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path fill="#ECF3FF" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
      <path
        fill="#4E56EA"
        d="M17.01 20.678V18.39l-7.844 6.822 7.843 6.746V29.77c6.655-.082 12.74-3.402 12.74-6.755v-6.67c-3.157 4.295-11.41 4.352-12.74 4.333Z"
      />
      <path
        fill="#4E56EA"
        d="M29.437 13.618c-.581-5.312-9.128-6.367-12.428-6.576v8.667c4.476.192 7.105 1.594 8.066 2.031.772-.366 3.477-1.787 4.362-4.122Z"
      />
    </svg>
  )
}

function AutoResponderDisabledIcon(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <path fill="#F2F4F6" d="M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
      <path
        fill="#607890"
        d="M17.01 20.678V18.39l-7.844 6.822 7.843 6.746V29.77c6.655-.082 12.74-3.402 12.74-6.755v-6.67c-3.157 4.295-11.41 4.352-12.74 4.333Z"
      />
      <path
        fill="#607890"
        d="M29.437 13.618c-.581-5.312-9.128-6.367-12.428-6.576v8.667c4.476.192 7.105 1.594 8.066 2.031.772-.366 3.477-1.787 4.362-4.122Z"
      />
    </svg>
  )
}

// ---------------------------------------------------------------------------
// Export map
// ---------------------------------------------------------------------------

export {
  ReapitPMIcon,
  ReapitPMDisabledIcon,
  ReapitLettingsIcon,
  ReapitLettingsDisabledIcon,
  ReapitSalesIcon,
  ReapitSalesDisabledIcon,
  KeyWhereIcon,
  KeyWhereDisabledIcon,
  LettingsBDMIcon,
  LettingsBDMDisabledIcon,
  MoveMeInIcon,
  MoveMeInDisabledIcon,
  ReapitFormsIcon,
  ReapitFormsDisabledIcon,
  ReapitProposalsIcon,
  ReapitProposalsDisabledIcon,
  ReapitWebsitesIcon,
  ReapitWebsitesDisabledIcon,
  AutoResponderIcon,
  AutoResponderDisabledIcon,
}
